/**
 * Фильтр «Кто» на вкладке «Метрики платформы» (решение владельца 14.10.2026):
 * сотрудники, клиенты, партнёры, служебные учётки. Группу по роли учётки
 * ставит bit-metrics (audience.py); здесь — подписи, цвета столбика и выбор.
 * Пустой выбор и есть «Все».
 */
export const AUDIENCES = [
  ['employees', 'Сотрудники', '#000000'],
  ['clients', 'Клиенты', '#E50071'],
  ['partners', 'Партнёры', '#7a5cff'],
  ['services', 'Сервисы', '#9bb0a5'],
];

export const audienceLabel = (id) => (AUDIENCES.find(([key]) => key === id) || [])[1] || '—';
export const audienceColor = (id) => (AUDIENCES.find(([key]) => key === id) || [])[2] || '#a0a0a0';

/** Нажатие на группу: добавить или снять; все четыре или ни одной — «Все». */
export function toggleAudience(selected, id) {
  const next = selected.includes(id) ? selected.filter((g) => g !== id) : [...selected, id];
  return next.length === AUDIENCES.length ? [] : next;
}

/** Параметр `audience` ручек bit-metrics: группы в порядке столбика, «Все» — без него. */
export function audienceParam(selected) {
  if (!selected.length) return undefined;
  return AUDIENCES.map(([id]) => id).filter((id) => selected.includes(id)).join(',');
}
